import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-jquiaccordion',
	templateUrl:'./JQUIAccordionPluginCompPage.html',
	styles: [],
	styleUrls:['./JQUIAccordionPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQUIAccordionPluginCompPage
{
	mdContent_997 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.accordion.JQUIAccordion;
\`\`\``;
	mdContent_998 = `\`\`\`java
JQUIAccordion()
\`\`\``;
	mdContent_999 = `\`\`\`java
JQUIAccordion&lt;?&gt; accordion = new JQUIAccordion&lt;&gt;();
accordion.addAccordianTab(tab1);
accordion.addAccordianTab(tab2);
accordion.getOptions().setCollapsible(true);
accordion.getOptions().getAnimate().setEasing(JQEasingEffects.easeInBack);
\`\`\``;
}
